module.exports = __webpack_public_path__ + "img/ads7.49d5f05.webp";